module.exports = __webpack_public_path__ + "static/media/paper.f8dd6ee9.svg";